module Dashboard {
    "use strict";

    export function executionGraphDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: { config: "=" },
            templateUrl: "executionGraphWidgetTemplate.htm",
            controller: "executionGraphController as ctrl"
        }
    }
    module.directive("frendsExecutionGraphWidget", [executionGraphDirective]);

    export class ExecutionGraphController {
        public config: ExecutionGraphWidgetConfig;
        public chartData: any;
        public chartOptions: any;

        public static $inject = ["$http", "$interval", "$timeout"];
        constructor(private $http: ng.IHttpService, private $interval: ng.IIntervalService, private $timeout) {
            this.setChartOptions();
            $timeout(() => this.fetch(), 50); // Wait a bit for gridster to finish rendering the container before initializing graph data
            $timeout(() => $interval(() => this.fetch(), 10 * 60 * 1000), Math.random() * 30 * 1000); // 10 minutes refresh, start delayed by 0-30 sec
        }

        private fetch() {
            let query = {
                environments: this.config.environments,
                rangeInDays: this.config.rangeInDays,
                successfulState: this.config.showingSuccesses
            };
            return this.$http.post("Status/ProcessExecutionsTimeSeries", query).then((response: Frends.IJsonResponse) => {
                if (response.data && response.data.success) {
                    let series = [];
                    _.each(response.data.data, (dataPoint: IChartDataPoint, index: number) => {
                        const local = moment.utc(dataPoint.date).toDate();
                        series.push({ label: local, value: dataPoint.count });
                    });
                    this.chartData = { series: series };
                }
            });
        }

        private isShortRange(): boolean {
            return (this.config.rangeInDays === 1 || this.config.rangeInDays === 3);
        }

        public updateSettingsCallback(config: ExecutionGraphWidgetConfig) {
            this.config = config;
            this.fetch().then(() => { this.updateChartOptions(); });
        }

        public setChartOptions() {
            let labelFormat = this.isShortRange() ? "HH:mm" : "MMM D";
            let tooltipFormat = this.isShortRange() ? "MMMM DD, HH:mm" : "MMMM DD";
            let timeLimitDays = this.config.rangeInDays || 60;
            this.chartOptions = {
                series: [
                    {
                        axis: "y",
                        dataset: "series",
                        key: "value",
                        label: this.config.showingSuccesses ? FRENDS.Localizations.Successful : FRENDS.Localizations.Failed,
                        interpolation: { mode: "linear" }, //cardinal rounds the corners
                        color: this.config.showingSuccesses ? "#16A765" : "#D14836",
                        type: ["line", "area"], // line, dot, column, area
                        id: "ProcessExecutionsChart"
                    }
                ],
                axes: {
                    x: {
                        key: "label",
                        type: "date",
                        ticks: 4,
                        tickFormat: (value, index) => {
                            if (this.isShortRange() && value.getHours() === 0 && value.getMinutes() === 0) {
                                return moment(value).format("MMM D");
                            } else {
                                return moment(value).format(labelFormat);
                            }
                        }
                    },
                    y: {
                        min: 0,
                        ticks: 4
                    }
                },
                grid: {x: false, y: true},
                margin: { top: 40, right: 0, bottom: 20, left: 70 },
                tooltipHook: (data) => {
                    if (data && data[0]) {
                        let tooltip = data[0];
                        let tooltipDate = moment(tooltip.row.x).format(tooltipFormat);
                        let label = tooltip.series.label + ":";
                        let value = tooltip.row.y1;
                        return { abscissas: tooltipDate, rows: [{ label: label, value: value }] };
                    }
                }
            };
        }

        public updateChartOptions() {
            this.chartOptions = undefined;
            this.$timeout(() => { this.setChartOptions(); }, 0);
        }
    }
    module.controller("executionGraphController", ExecutionGraphController);
}